// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1YE_u","location":"Header_location__2keNP"};